import { AppShell, Container, Group, Title } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import { UserMenu } from '../components/UserMenu';

/**
 * Parent / student layout — top-nav, mobil-first.
 * Sidebar nincs; a tartalom kártyás listákban jelenik meg az Outlet-ben.
 */
export function ParentLayout() {
  return (
    <AppShell header={{ height: 56 }} padding="md">
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Title order={4}>PTA</Title>
          <UserMenu />
        </Group>
      </AppShell.Header>

      <AppShell.Main>
        <Container size="md">
          <Outlet />
        </Container>
      </AppShell.Main>
    </AppShell>
  );
}
